import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgMoment({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.415l5.315 5.316c-.743.176-1.518.269-2.315.269a9.997 9.997 0 01-3-.458v-5.127zm3.415.585l8.247.001a10.045 10.045 0 01-4.264 3.983L12.415 17l8.247.001L12.415 17zM7 12.414v8.248A10.044 10.044 0 013.017 16.4L7 12.414zM16.414 15l5.317-5.315c.176.743.269 1.518.269 2.315 0 1.046-.16 2.054-.458 3h-5.128l5.317-5.315L16.414 15zM2.458 9h5.126l-5.315 5.316A10.028 10.028 0 012 12c0-1.045.16-2.053.458-3zM17 11.584l.001-8.246a10.045 10.045 0 013.983 4.264L17 11.584l.001-8.246L17 11.584zM12 2c1.046 0 2.054.16 3 .458v5.127L9.684 2.269C10.428 2.093 11.203 2 12 2zM7.601 3.017L11.585 7H3.338A10.047 10.047 0 017.27 3.187l.331-.17z"
        fill={color}
      />
    </svg>
  )
}

export default SvgMoment
